
 const FOOTER_DATA = {
  "footer_upper": [
    {
      "id": "footer-about-airtel",
      "name": "À propos d'Airtel",
      "translatedName": "À propos d'Airtel",
      "link": "",
      "translatedLink": "",
      "className": "clear",
      "in18": "quick_access",
      "child": [
        {
          "className": "",
          "name": "Carrières",
          "translatedName": "Carrières",
          "link": "career",
          "translatedLink": ""
        },
        {
          "className": "",
          "name": "Médias",
          "translatedName": "Médias",
          "link": "media",
          "translatedLink": ""
        }
      ]
    },
    {
      "id": "footer-quick-access",
      "name": "Accès rapide",
      "translatedName": "Accès rapide",
      "link": "",
      "translatedLink": "",
      "className": "",
      "in18": "quick_access",
      "child": [
        {
          "className": "",
          "name": "Airtel Money",
          "translatedName": "Airtel Money",
          "imageUrl": "",
          "link": "airtel_money",
          "translatedLink": ""
        }
      ]
    },
    {
      "id": "help-at-hand",
      "name": "Aide à la main",
      "translatedName": "Aide à la main",
      "link": "",
      "translatedLink": "",
      "className": "list-unstyled footer-nav",
      "in18": "help_at_hand",
      "child": [
        {
          "className": "",
          "name": "Vérifier la couverture",
          "translatedName": "Vérifier la couverture",
          "link": "openNetworks",
          "translatedLink": "openNetworks"
        },
        {
          "className": "",
          "name": "Trouver un magasin",
          "translatedName": "Trouver un magasin",
          "link": "storeLocator",
          "translatedLink": "storeLocator"
        },
        {
          "className": "",
          "name": "Donnez-nous votre avis",
          "translatedName": "Donnez-nous votre avis",
          "link": "give_your_feedback",
          "translatedLink": "give_your_feedback"
        }
      ]
    },
    {
      "id": "privacy",
      "name": "Privacy",
      "translatedName": "",
      "link": "",
      "translatedLink": "",
      "className": "",
      "in18": "airtel-applications",
      "child": [
        {
          "className": "",
          "name": "Online Safety",
          "translatedName": "Online Safety",
          "link": "online-safety",
          "translatedLink": ""
        }
      ]
    }
  ],
  "social_media": [
    {
      "className": "facebook icon-filled-facebook",
      "link": "https://www.facebook.com/airtelgabon",
      "name": "facebook",
      "translatedName": "facebook"
    },
    {
      "className": "instagram ng-icon-outlined-Instagram-Logo-Black",
      "link": "https://www.instagram.com/airtel_ga/",
      "name": "instagram",
      "translatedName": "instagram"
    },
    {
      "className": "twitter icon-filled-twitter",
      "link": "https://twitter.com/airtel_ga",
      "name": "twitter",
      "translatedName": "twitter"
    },
    {
      "className": "youtube icon-filled-youtube",
      "link": "https://www.youtube.com/user/airtelgabon",
      "name": "youtube",
      "translatedName": "youtube"
    }
  ],
  "bottom_footer": [
    {
      "className": "text-uppercase",
      "link": "contactez-nous",
      "name": "NOUS CONTACTER",
      "translatedName": "NOUS CONTACTER",
      "i18": "important_alerts",
      "click": ""
    },
    {
      "className": "text-uppercase",
      "link": "copyRightPrivacy",
      "name": "DROITS D'AUTEURS ET VIE PRIVÉES",
      "translatedName": "DROITS D'AUTEURS ET VIE PRIVÉES",
      "i18": "privacy_policy",
      "click": "copyRightPrivacyPopup('copyRightPrivacy')"
    },
    {
      "className": "",
      "link": "termCondition",
      "translatedLink": "",
      "name": "TERMES ET CONDITIONS",
      "translatedName": "TERMES ET CONDITIONS",
      "i18": "privacy_policy",
      "click": "termAndConditionPopup('termCondition')"
    },
    {
      "className": "",
      "link": "https://cdn-webportal.airtelstream.net/website/gabon/assets/pdf/CONFIDENTIALITE-AIRTEL.pdf",
      "translatedLink": "",
      "name": "CONFIDENTIALITE AIRTEL",
      "translatedName": "CONFIDENTIALITE AIRTEL",
      "i18": "privacy_policy",
      "click": ""
    },
    {
      "className": "",
      "link": "https://cdn-webportal.airtelstream.net/website/gabon/assets/pdf/conditions-abonnement.pdf",
      "translatedLink": "",
      "name": "CONDITIONS D' ABONNEMENT",
      "translatedName": "CONDITIONS D' ABONNEMENT",
      "i18": "privacy_policy",
      "click": ""
    },
    {
      "className": "",
      "link": "https://cdn-webportal.airtelstream.net/website/gabon/assets/pdf/CONFIDENTIALITE-AIRTEL-MONEY.pdf",
      "translatedLink": "",
      "name": "CONFIDENTIALITE AIRTEL MONEY",
      "translatedName": "CONFIDENTIALITE AIRTEL MONEY",
      "i18": "privacy_policy",
      "click": "https://cdn-webportal.airtelstream.net/website/gabon/assets/pdf/CONFIDENTIALITE-AIRTEL-MONEY.pdf"
    },
    {
      "className": "",
      "link": "businesstermCondition",
      "translatedLink": "",
      "name": "BUSINESS TERMES ET CONDITIONS",
      "translatedName": "BUSINESS TERMES ET CONDITIONS",
      "i18": "privacy_policy",
      "click": "termAndConditionPopup('businesstermCondition')"
    }
  ],
  "bottom_footer_logos": [
    {
      "className": "",
      "logoImg": "",
      "link": "",
      "name": "",
      "translatedName": ""
    }
  ],
  "copyRight": [
    {
      "copyText": "© 2024 Airtel Africa. Tous Droits Réservés.",
      "translatedCopyText": "© 2024 Airtel Africa. Tous Droits Réservés.",
      "backTop": "HAUT DE PAGE",
      "translatedbackTop": "HAUT DE PAGE"
    }
  ]
 }
 
export default FOOTER_DATA;